import { createContext } from 'react';

// 创建语言上下文
export const LanguageContext = createContext({
  language: 'zh-CN', // 默认语言为中文
  setLanguage: () => {}, // 占位函数，实际实现在App组件中
}); 